import $ from 'jquery'
import store_soins from "@/store/mods/clinique/soins"

export default {
    name: 'm-chirurgies',
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_chirurgie: '',
            filtered_chirurgies: [],
            selected_prestations: [],

            all_checked: false,
			each_cat_is_checked: [],
            text_grey: [],
            chrg_is_loading: true,
            chrg_is_empty: false,

            liste_chirurgies: []
        }
    },

    watch: {
        filter_chirurgie() {
            this.filterChirurgie()
        },

        one_is_checked() {
            console.log(this.one_is_checked);
            this.choice_is_empty = false
        },

        refresh_state() {
            this.fetchChirurgie()
        }
    },

    computed: {
        
    },

    mounted() {
        this.fetchChirurgie()
    },

    methods: {
        fetchChirurgie() {
            this.chrg_is_loading = true
            store_soins.getListeChirurgies().then((liste_chirurgies) => {
                this.liste_chirurgies = liste_chirurgies
                if (this.liste_chirurgies.length == 0) {
                    this.chrg_is_empty = true
                } else {
                    this.chrg_is_empty = false
                    this.filtered_chirurgies = this.liste_chirurgies
                }

                this.chrg_is_loading = false
            })
        },

        hadleUndefinedPrice() {
            this.warningToast("Le prix de cette chirurgie n'a pas été défini !")
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.save_loading = true

            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked,
                type_prestation: 'Chirurgie',
                data_type: 'chirurgie',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: (this.info_patient.sexe == 'Masculin')?'H':'F',
                    telephone: this.info_patient.telephone_mobile,
                    num_patient: this.info_patient.num_patient
                }
            }

            this.$store.dispatch('saveVentePrestation', data).then((response) => {
                if (response.success) {
                    this.successToast('Ajout effectué avec succès')

                    this.$emit('emitPrestation', response.fpro_id)

                    this.one_is_checked = []
                    this.$refs.fpro_chirurgie.click()

                    if (response.fpro_id > 0) {
                        this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                    }
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response === 403) {
                        this.permission_is_denied = true
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        filterChirurgie() {
            this.filtered_chirurgies = [];

            if (this.filter_chirurgie == '') {
                this.filtered_chirurgies = this.liste_chirurgies
            } else {
                this.liste_chirurgies.forEach((categorie_chirurgie) => {
                    categorie_chirurgie.kchirurgies.forEach(chirurgie => {
                        let cleaned_chirurgie = this.removeAccents(chirurgie.k_chirurgie)
                        let cleaned_filter = this.removeAccents(this.filter_chirurgie)
    
                        if (cleaned_chirurgie.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                            this.filtered_chirurgies.push(chirurgie)
                        }
                    });
                });
                
            }
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#kchirurgie-tous'+index).is(":checked")

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.liste_chirurgies.forEach((categorie_chirurgie) => {
                if (categorie_chirurgie.chirurgie_id == index) {

                    let one_price_is_undefined = false

                    categorie_chirurgie.kchirurgies.forEach((_data) => {
                        this.text_grey[_data.id] = (is_checked)?'text-grey':''

                        const tmp_chirurgie = {
                            id: _data.id,
                            parent_id: categorie_chirurgie.chirurgie_id,
                            kid: _data.k_id,
                            nom: _data.k_chirurgie,
                            prix: _data.pu
                        }
                        if (is_checked) {
                            if (_data.pu == undefined) {
                                one_price_is_undefined = true
                            }
                            this.one_is_checked.push(tmp_chirurgie)
                        } else {
                            this.one_is_checked = this.one_is_checked.filter(item => item.id != tmp_chirurgie.id)
                        }
                    })

                    if (one_price_is_undefined) {
                        this.warningToast("Le prix d'une ou plusieurs chirurgies (décochée(s) dans la liste) n'a pas été défini !")
                    }
                }
            });
            
            this.all_checked = is_checked
        },
    }
}